import { useQuery } from "react-query";
import { namesUseQuery } from "../../utils/constants";
import { PersonService } from "../../services/PersonService";

export function useGetPersonById(id) {
  const { data, isLoading } = useQuery(
    [namesUseQuery?.GET_PERSON_BY_ID, id],
    () => PersonService.getPersonById(id),
    {
      enabled: true,
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return {
    data: data?.[0],
    isLoading,
  };
}
